import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const NewWindow20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.5 1.24994C1.80964 1.24994 1.25 1.80958 1.25 2.49994V11.9999H2.75V5.75H17.25V17.2499H8V18.7499H17.5C18.1904 18.7499 18.75 18.1903 18.75 17.4999V2.49994C18.75 1.80958 18.1904 1.24994 17.5 1.24994H2.5ZM4.25 4.25H2.75V2.74994H4.25V4.25ZM5.75 4.25H17.25V2.74994H5.75V4.25Z'
      fill='currentColor'
    />
    <path
      d='M5 10.25H8.68939L1.46973 17.4697L2.53039 18.5303L9.75002 11.3107V15H11.25V8.75H5V10.25Z'
      fill='currentColor'
    />
  </Svg>
);

NewWindow20.displayName = 'NewWindow20';
export default NewWindow20;
